import { OrderRepository } from "../../../../data/repository/order/OrderRepository";
import { ResponseState, State } from "../../../model/ResponseState";

export interface DeliverOrderUseCase {
  invoke: (id: string) => Promise<ResponseState<{ message: string; deliveryInfo: any }>>;
}

export class DeliverOrderUseCaseImpl implements DeliverOrderUseCase {
  private repository: OrderRepository;

  constructor(repository: OrderRepository) {
    this.repository = repository;
  }

  async invoke(id: string): Promise<ResponseState<{ message: string; deliveryInfo: any }>> {
    try {
      let response = await this.repository.deliver(id);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
